<div class="w-full flex flex-col items-center justify-start gap-4">
  @if (data()?.labels?.length && data()?.dataset?.data) {
    <div class="w-full flex flex-col gap-1">
      @for (label of data().labels; track $index; let index = $index) {
        <span class="flex items-center gap-1">
          <div [class]="'h-2 w-2 rounded-full ' + getColor(index)"></div>
          <span class="text-sm text-zinc-500">{{ label }}</span>
          <span class="text-sm text-zinc-500">{{ data()?.dataset?.data[index] | currency }}</span>
        </span>
      }
    </div>
  }
  @if (data()?.dataset?.data) {
    <div class="w-full flex flex-row items-center h-5 rounded-lg overflow-hidden gap-1">
      @for (item of data().dataset.data; track $index; let index = $index) {
        <div
          [class]="'h-full ' + getColor(index)"
          [style.width.%]="getPertentItem(index)"
        ></div>
      }
    </div>
  }
</div>
